import { render } from "./Home.vue?vue&type=template&id=f4a54798"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=f4a54798&lang=scss"

import exportComponent from "C:\\Users\\grego\\Documents\\Projets_info\\New-project\\gregoire-aimier-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__